import { render } from "./Burger.vue?vue&type=template&id=117f819b&lang=pug"
import script from "./Burger.vue?vue&type=script&setup=true&lang=js"
export * from "./Burger.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__